import React from 'react';

const bars = ({ colorStroke }) => ({
  viewBox: '0 0 22 23',
  data: (
    <g>
      <mask
        id="bars-svg"
        fill="white"
      >
        <rect
          x="0.146484"
          y="0.733398"
          width="22"
          height="22"
          rx="1"
        />
      </mask>
      <rect
        x="0.146484"
        y="0.733398"
        width="22"
        height="22"
        rx="1"
        stroke={colorStroke}
        fill="none"
        strokeWidth="4"
        mask="url(#bars-svg)"
      />
      <line
        x1="22"
        y1="8.5957"
        x2="0.145344"
        y2="8.5957"
        stroke={colorStroke}
        fill="none"
        strokeWidth="2"
      />
      <line
        x1="22"
        y1="14.584"
        x2="0.145344"
        y2="14.584"
        stroke={colorStroke}
        fill="none"
        strokeWidth="2"
      />
    </g>
  ),
});

export default bars;
